import ReviewCard from "./OverviewReviewCard";

export default function NeedsAttentionCard({
  reviews = [],
  pendingCount = 0,
  loading = false,
}) {
  return (
    <section className="bg-white border border-slate-200 rounded-2xl shadow-sm p-6">
      <div className="flex items-center justify-between gap-4 mb-5">
        <div>
          <h2 className="text-lg font-semibold text-slate-900">
            Needs Attention
          </h2>

          <p className="text-sm text-slate-500">
            Reviews awaiting approval, response, or manual review.
          </p>
        </div>

        <span className="rounded-full bg-orange-50 px-3 py-1 text-sm font-medium text-orange-700">
          {pendingCount} pending
        </span>
      </div>

      {loading ? (
        <p className="text-slate-500">Loading action items...</p>
      ) : reviews.length > 0 ? (
        <div className="space-y-4">
          {reviews.map((review) => (
            <ReviewCard
              key={review.id}
              name={review.authorName}
              date={formatDate(review.reviewDate)}
              rating={review.rating}
              review={review.content}
              suggestedResponse={review.suggestedResponse}
              status={mapStatus(review.status)}
            />
          ))}
        </div>
      ) : (
        <div className="rounded-xl border border-green-200 bg-green-50 p-5">
          <h3 className="font-semibold text-green-900">You’re all caught up</h3>

          <p className="text-sm text-green-700 mt-1">
            No reviews currently need your attention.
          </p>
        </div>
      )}
    </section>
  );
}

function formatDate(date) {
  if (!date) return "Unknown date";

  return new Date(date).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

function mapStatus(status) {
  if (!status) return "needs_response";

  if (
    status === "pending_response" ||
    status === "draft_generated" ||
    status === "needs_approval" ||
    status === "new"
  ) {
    return "needs_response";
  }

  return status;
}
